export default "__VITE_ASSET__53162693__"